module.exports = __webpack_public_path__ + "media/images/horses/Vita-Flex-E-and-Selenium-Supplement-for-Horses.jpeg";